const DEFAULT_API_BASE_URL = 'http://localhost:5001';
export const API_BASE_URL_STORAGE_KEY = 'percurso:apiBaseUrl';

const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

const getRuntimeApiBaseUrl = () => {
  if (typeof window === 'undefined') return '';
  return window.appConfig?.API_BASE_URL || '';
};

/** Same-origin (Caddy/proxy): empty base → `/api/...` relative to the page. */
const isBrowserSameOriginDeploy = () => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return Boolean(host && host !== 'localhost' && host !== '127.0.0.1');
};

export const getStoredApiBaseUrl = () => {
  if (typeof localStorage === 'undefined') return '';
  try {
    return trimTrailingSlash(localStorage.getItem(API_BASE_URL_STORAGE_KEY) || '');
  } catch {
    return '';
  }
};

export const setStoredApiBaseUrl = (url) => {
  if (typeof localStorage === 'undefined') return;
  const cleaned = trimTrailingSlash(url);
  if (!cleaned) {
    localStorage.removeItem(API_BASE_URL_STORAGE_KEY);
    return;
  }
  localStorage.setItem(API_BASE_URL_STORAGE_KEY, cleaned);
};

const isLoopbackApiBase = (url) => {
  try {
    const { hostname } = new URL(url.includes('://') ? url : `http://${url}`);
    return hostname === 'localhost' || hostname === '127.0.0.1';
  } catch {
    return false;
  }
};

export const getApiBaseUrl = (env = import.meta.env) => {
  const stored = getStoredApiBaseUrl();
  // Ignore a leftover localhost override when the app is served in production.
  if (stored && !(isBrowserSameOriginDeploy() && isLoopbackApiBase(stored))) {
    return stored;
  }

  const runtime = getRuntimeApiBaseUrl();
  if (runtime) return trimTrailingSlash(runtime);

  // Explicit empty VITE_API_BASE_URL = same-origin (production behind Caddy).
  if (
    Object.prototype.hasOwnProperty.call(env, 'VITE_API_BASE_URL')
    && String(env.VITE_API_BASE_URL ?? '') === ''
  ) {
    return '';
  }

  if (env.VITE_API_BASE_URL) {
    return trimTrailingSlash(env.VITE_API_BASE_URL);
  }

  if (isBrowserSameOriginDeploy()) {
    return '';
  }

  return DEFAULT_API_BASE_URL;
};

/** Resolve at call time so Conta Settings can change URL without reload of module. */
export const apiUrl = (path, baseUrl = getApiBaseUrl()) => {
  if (/^https?:\/\//i.test(path)) return path;

  const normalizedPath = String(path || '').startsWith('/') ? path : `/${path}`;
  return `${trimTrailingSlash(baseUrl)}${normalizedPath}`;
};

/** @deprecated Prefer getApiBaseUrl() — kept for modules that imported the constant. */
export const API_BASE_URL = getApiBaseUrl();
